/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { tituloEmpleoActivosGet } from '../fn/job-title/titulo-empleo-activos-get';
import { TituloEmpleoActivosGet$Params } from '../fn/job-title/titulo-empleo-activos-get';
import { tituloEmpleoEstadoIdJobTitlePatch } from '../fn/job-title/titulo-empleo-estado-id-job-title-patch';
import { TituloEmpleoEstadoIdJobTitlePatch$Params } from '../fn/job-title/titulo-empleo-estado-id-job-title-patch';
import { tituloEmpleoExisteExisteGet } from '../fn/job-title/titulo-empleo-existe-existe-get';
import { TituloEmpleoExisteExisteGet$Params } from '../fn/job-title/titulo-empleo-existe-existe-get';
import { tituloEmpleoExisteTituloEmpleoGet } from '../fn/job-title/titulo-empleo-existe-titulo-empleo-get';
import { TituloEmpleoExisteTituloEmpleoGet$Params } from '../fn/job-title/titulo-empleo-existe-titulo-empleo-get';
import { tituloEmpleoGet } from '../fn/job-title/titulo-empleo-get';
import { TituloEmpleoGet$Params } from '../fn/job-title/titulo-empleo-get';
import { tituloEmpleoIdJobTitleGet } from '../fn/job-title/titulo-empleo-id-job-title-get';
import { TituloEmpleoIdJobTitleGet$Params } from '../fn/job-title/titulo-empleo-id-job-title-get';
import { tituloEmpleoIdJobTitlePatch } from '../fn/job-title/titulo-empleo-id-job-title-patch';
import { TituloEmpleoIdJobTitlePatch$Params } from '../fn/job-title/titulo-empleo-id-job-title-patch';
import { tituloEmpleoPost } from '../fn/job-title/titulo-empleo-post';
import { TituloEmpleoPost$Params } from '../fn/job-title/titulo-empleo-post';
import { tituloEmpleoTituloEmpleoGet } from '../fn/job-title/titulo-empleo-titulo-empleo-get';
import { TituloEmpleoTituloEmpleoGet$Params } from '../fn/job-title/titulo-empleo-titulo-empleo-get';

@Injectable({ providedIn: 'root' })
export class JobTitleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tituloEmpleoGet()` */
  static readonly TituloEmpleoGetPath = '/titulo-empleo';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoGet$Response(params?: TituloEmpleoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoGet(params?: TituloEmpleoGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoPost()` */
  static readonly TituloEmpleoPostPath = '/titulo-empleo';

  /**
   * insert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoPost$Response(params?: TituloEmpleoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * insert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoPost(params?: TituloEmpleoPost$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoIdJobTitleGet()` */
  static readonly TituloEmpleoIdJobTitleGetPath = '/titulo-empleo/{idJobTitle}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoIdJobTitleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoIdJobTitleGet$Response(params: TituloEmpleoIdJobTitleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoIdJobTitleGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoIdJobTitleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoIdJobTitleGet(params: TituloEmpleoIdJobTitleGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoIdJobTitleGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoIdJobTitlePatch()` */
  static readonly TituloEmpleoIdJobTitlePatchPath = '/titulo-empleo/{idJobTitle}';

  /**
   * update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoIdJobTitlePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoIdJobTitlePatch$Response(params: TituloEmpleoIdJobTitlePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoIdJobTitlePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoIdJobTitlePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoIdJobTitlePatch(params: TituloEmpleoIdJobTitlePatch$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoIdJobTitlePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoEstadoIdJobTitlePatch()` */
  static readonly TituloEmpleoEstadoIdJobTitlePatchPath = '/titulo-empleo/estado/{idJobTitle}';

  /**
   * updateStateByIdJobTitle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoEstadoIdJobTitlePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoEstadoIdJobTitlePatch$Response(params: TituloEmpleoEstadoIdJobTitlePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoEstadoIdJobTitlePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * updateStateByIdJobTitle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoEstadoIdJobTitlePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tituloEmpleoEstadoIdJobTitlePatch(params: TituloEmpleoEstadoIdJobTitlePatch$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoEstadoIdJobTitlePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoExisteTituloEmpleoGet()` */
  static readonly TituloEmpleoExisteTituloEmpleoGetPath = '/titulo-empleo/existe/titulo_empleo';

  /**
   * existByName.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoExisteTituloEmpleoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoExisteTituloEmpleoGet$Response(params?: TituloEmpleoExisteTituloEmpleoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoExisteTituloEmpleoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByName.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoExisteTituloEmpleoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoExisteTituloEmpleoGet(params?: TituloEmpleoExisteTituloEmpleoGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoExisteTituloEmpleoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoExisteExisteGet()` */
  static readonly TituloEmpleoExisteExisteGetPath = '/titulo-empleo/existe/existe';

  /**
   * existByNameDiffIdJobTitle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoExisteExisteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoExisteExisteGet$Response(params?: TituloEmpleoExisteExisteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoExisteExisteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByNameDiffIdJobTitle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoExisteExisteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoExisteExisteGet(params?: TituloEmpleoExisteExisteGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoExisteExisteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoActivosGet()` */
  static readonly TituloEmpleoActivosGetPath = '/titulo-empleo/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoActivosGet$Response(params?: TituloEmpleoActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoActivosGet(params?: TituloEmpleoActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tituloEmpleoTituloEmpleoGet()` */
  static readonly TituloEmpleoTituloEmpleoGetPath = '/titulo-empleo/titulo_empleo';

  /**
   * getByName.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tituloEmpleoTituloEmpleoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoTituloEmpleoGet$Response(params?: TituloEmpleoTituloEmpleoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tituloEmpleoTituloEmpleoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByName.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tituloEmpleoTituloEmpleoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tituloEmpleoTituloEmpleoGet(params?: TituloEmpleoTituloEmpleoGet$Params, context?: HttpContext): Observable<any> {
    return this.tituloEmpleoTituloEmpleoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
